import React, { createContext } from 'react';
import { CarouselDisplayStyle } from '@honeycomb/data';
export const GenericRootComponentContext = createContext({
    carouselDisplayStyle: CarouselDisplayStyle.Default,
    isBackgroundDark: false,
});
export function useGenericRootComponent() {
    return React.useContext(GenericRootComponentContext);
}
